const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconQuitBlue(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h36v36H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 1333",
    d: "m895.026 43.792-4.814-4.814a1 1 0 0 0-1.414 1.414L891.9 43.5h-10.819a1 1 0 0 0 0 2h10.826l-3.107 3.106a1 1 0 1 0 1.414 1.414l4.814-4.814a1 1 0 0 0 0-1.414z",
    style: {
      fill: "#4495ff"
    },
    transform: "translate(-866.318 -26.5)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 1334",
    d: "M881.541 53.5h-6.221v-18h6.221a1 1 0 0 0 0-2h-6.581a1.12 1.12 0 0 0-.13.008 1.731 1.731 0 0 0-1.51 1.842v18.3a1.731 1.731 0 0 0 1.51 1.842 1.12 1.12 0 0 0 .13.008h6.581a1 1 0 0 0 0-2z",
    style: {
      fill: "#4495ff"
    },
    transform: "translate(-866.318 -26.5)"
  }));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuitBlue);
export default __webpack_public_path__ + "static/media/icon-quit-blue.0dff52e4433a1048aa66ee2ab6feeea5.svg";
export { ForwardRef as ReactComponent };